import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import "./PersonPublicForm.css";

const API =
  (process.env.REACT_APP_API_URL && process.env.REACT_APP_API_URL.trim()) ||
  (window.location.hostname === "localhost" ? "http://localhost:5000" : window.location.origin);



const STRINGS = {
  en: {
    titlePrefix: "",
    subtitle: "Please share your memories or thoughts",
    fullName: "Your Full Name",
    mobile: "Your Mobile Number",
    optional: "Optional",
    contribution: "Your Contribution",
    hint: "Share your story, thoughts, or memories.",
    phFull: "Enter your full name",
    phMobile: "Enter your mobile number",
    phContribution: "Write your contribution here...",
    addMedia: "Add Media",
    uploadPhoto: "Upload Photo",
    uploadVideo: "Upload Video",
    uploadAudio: "Upload Audio",
    addLink: "Add Link",
    linkPlaceholder: "Paste a link (https://...)",
    note: "All submissions will be reviewed before being published.",
    submit: "Submit Contribution",
    success: "Submitted successfully. It will be reviewed before publishing.",
    tittlesufix: "Former Union Minister",
    lang: "ಕನ್ನಡ",

  },
  kn: {
    titlePrefix: "",
    subtitle: "ನಿಮ್ಮೊಂದಿಗೆ ಇದ್ದ  ಒಡನಾಟದ ನೆನಪುಗಳು  ಹಾಗೂ  ಅವರ  ಬಗ್ಗೆ  ಇರುವ  ನಿಮ್ಮ  ಅಭಿಪ್ರಾಯಗಳನ್ನು  ಹಂಚಿಕೊಳ್ಳಿ",
    fullName: "ನಿಮ್ಮ ಪೂರ್ಣ ಹೆಸರು",
    mobile: "ನಿಮ್ಮ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ",
    optional: "ಐಚ್ಛಿಕ",
    contribution: "ನಿಮ್ಮ ಕೊಡುಗೆ",
    hint: "ನಿಮ್ಮ ಕಥೆ/ಅಭಿಪ್ರಾಯ/ನೆನಪುಗಳನ್ನು ಬರೆಯಿರಿ.",
    phFull: "ನಿಮ್ಮ ಪೂರ್ಣ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
    phMobile: "ನಿಮ್ಮ ಮೊಬೈಲ್ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
    phContribution: "ಇಲ್ಲಿ ಬರೆಯಿರಿ...",
    addMedia: "ಮಾಧ್ಯಮ ಸೇರಿಸಿ",
    uploadPhoto: "ಫೋಟೋ ಅಪ್‌ಲೋಡ್",
    uploadVideo: "ವೀಡಿಯೋ ಅಪ್‌ಲೋಡ್",
    uploadAudio: "ಆಡಿಯೋ ಅಪ್‌ಲೋಡ್",
    addLink: "ಲಿಂಕ್ ಸೇರಿಸಿ",
    linkPlaceholder: "ಲಿಂಕ್ ಅಂಟಿಸಿ (https://...)",
    note: "ಎಲ್ಲಾ ಸಲ್ಲಿಕೆಗಳನ್ನು ಪ್ರಕಟಿಸುವ ಮೊದಲು ಪರಿಶೀಲಿಸಲಾಗುತ್ತದೆ.",
    submit: "ಸಲ್ಲಿಸಿ",
    success: "ಸಲ್ಲಿಸಲಾಗಿದೆ. ಪ್ರಕಟಿಸುವ ಮೊದಲು ಪರಿಶೀಲಿಸಲಾಗುತ್ತದೆ.",
    tittlesufix: "ಮಾಜಿ ಕೇಂದ್ರ ಸಚಿವರು",
    lang: "English",
  },
};

function absUrl(u) {
  if (!u) return "";
  const clean = String(u).trim().replace(/\\/g, "/");

  // If absolute URL, rewrite localhost/127.0.0.1 to our current API origin
  if (clean.startsWith("http://") || clean.startsWith("https://")) {
    try {
      const x = new URL(clean);
      if (x.hostname === "localhost" || x.hostname === "127.0.0.1") {
        return `${API}${x.pathname}`; // keep /uploads/... path, replace host
      }
    } catch {}
    return clean; // other absolute URLs remain unchanged
  }

  if (clean.startsWith("/")) return `${API}${clean}`;
  return `${API}/${clean}`;
}


export default function PersonPublicForm() {
  const slug = window.location.pathname.split("/").pop(); // route: /p/:slug
  const [lang, setLang] = useState(localStorage.getItem("lang") || "en");
  const t = useMemo(() => STRINGS[lang] || STRINGS.en, [lang]);

  const [person, setPerson] = useState(null);
  const [loading, setLoading] = useState(true);

  const [fullName, setFullName] = useState("");
  const [mobile, setMobile] = useState("");
  const [contribution, setContribution] = useState("");

  const [files, setFiles] = useState([]);
  const [linkUrl, setLinkUrl] = useState("");
  const [showLink, setShowLink] = useState(false);

  const [submitting, setSubmitting] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [photoFailed, setPhotoFailed] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const res = await axios.get(`${API}/api/public/persons/${slug}`);
        setPerson(res.data);
      } catch (e) {
        setPerson(null);
      } finally {
        setLoading(false);
      }
    })();
  }, [slug]);

  const onPick = (accept) => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = accept;
    input.multiple = false;
    input.onchange = (e) => {
      const f = e.target.files?.[0];
      if (f) setFiles((prev) => [...prev, f]);
    };
    input.click();
  };

  const removeFile = (idx) => setFiles((prev) => prev.filter((_, i) => i !== idx));

  const submit = async (e) => {
    e.preventDefault();
    setSuccessMsg("");

    if (!fullName.trim() || !contribution.trim()) {
      alert(lang === "kn" ? "ಹೆಸರು ಮತ್ತು ಕೊಡುಗೆ ಅಗತ್ಯ." : "Full Name and Contribution are required.");
      return;
    }

    try {
      setSubmitting(true);
      const fd = new FormData();
      fd.append("full_name", fullName.trim());
      fd.append("mobile", mobile.trim());
      fd.append("contribution_text", contribution.trim());
      fd.append("content_lang", lang === "kn" ? "kn" : "en"); // DB will still store Kannada fine
      if (linkUrl.trim()) fd.append("link_url", linkUrl.trim());
      files.forEach((f) => fd.append("files", f));

      await axios.post(`${API}/api/public/persons/${slug}/contributions`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      setSuccessMsg(t.success);
      setFullName("");
      setMobile("");
      setContribution("");
      setFiles([]);
      setLinkUrl("");
      setShowLink(false);
    } catch (err) {
      console.error(err);
      alert(err?.response?.data?.message || "Submit failed");
    } finally {
      setSubmitting(false);
    }
  };

  const toggleLang = () => {
    const next = lang === "en" ? "kn" : "en";
    setLang(next);
    localStorage.setItem("lang", next);
  };

  if (loading) return <div className="pf-wrap">Loading...</div>;
  if (!person) return <div className="pf-wrap">Person not found.</div>;

  const displayName = lang === "kn" ? (person.name_kn || person.name_en) : (person.name_en || person.name_kn);
  const photoUrl = person.photo_url ? absUrl(person.photo_url) : "";
  const initial = (displayName || "P").trim().slice(0, 1).toUpperCase();

  return (
    <div className="pf-page">
      <div className="pf-topbar">
        <button className="pf-lang-btn" onClick={toggleLang}>{t.lang}</button>
      </div>

      <div className="pf-wrap">
        {/* Circle photo (NO design change; only adds avatar above title) */}
        <div className="pf-person-avatar" aria-label="Person photo">
          {photoUrl && !photoFailed ? (
  <img
    className="pf-avatar-img"
    src={photoUrl}
    alt={displayName}
    onError={() => setPhotoFailed(true)}
  />
) : (
  <div className="pf-avatar-fallback" aria-hidden="true">{initial}</div>
)}

        </div>

        <h1 className="pf-title">
          {t.titlePrefix} {displayName} {t.tittlesufix}
        </h1>
        <p className="pf-subtitle">
          {t.subtitle}
        </p>

        <form className="pf-card" onSubmit={submit}>
          <div className="pf-group">
            <label className="pf-label">
              {t.fullName} <span className="pf-req">*</span>
            </label>
            <input
              className="pf-input"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              placeholder={t.phFull}
            />
          </div>

          <div className="pf-group">
            <label className="pf-label">
              {t.mobile} <span className="pf-opt">({t.optional})</span>
            </label>
            <input
              className="pf-input"
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
              placeholder={t.phMobile}
            />
          </div>

          <div className="pf-group">
            <label className="pf-label">
              {t.contribution} <span className="pf-req">*</span>
            </label>
            <div className="pf-hint">{t.hint}</div>
            <textarea
              className="pf-textarea"
              value={contribution}
              onChange={(e) => setContribution(e.target.value)}
              placeholder={t.phContribution}
              rows={8}
            />
          </div>

          <div className="pf-group">
            <label className="pf-label">
              {t.addMedia} <span className="pf-opt">({t.optional})</span>
            </label>

            <div className="pf-media-row">
              <button type="button" className="pf-media-btn" onClick={() => onPick("image/*")}>
                {t.uploadPhoto}
              </button>
              <button type="button" className="pf-media-btn" onClick={() => onPick("video/*")}>
                {t.uploadVideo}
              </button>
              <button type="button" className="pf-media-btn" onClick={() => onPick("audio/*")}>
                {t.uploadAudio}
              </button>
              <button type="button" className="pf-media-btn" onClick={() => setShowLink((s) => !s)}>
                {t.addLink}
              </button>
            </div>

            {showLink && (
              <div className="pf-linkbox">
                <input
                  className="pf-input"
                  value={linkUrl}
                  onChange={(e) => setLinkUrl(e.target.value)}
                  placeholder={t.linkPlaceholder}
                />
              </div>
            )}

            {files.length > 0 && (
              <div className="pf-files">
                {files.map((f, idx) => (
                  <div key={idx} className="pf-file">
                    <span className="pf-file-name">{f.name}</span>
                    <button type="button" className="pf-file-remove" onClick={() => removeFile(idx)}>
                      ✕
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="pf-note">{t.note}</div>
          {successMsg ? <div className="pf-success">{successMsg}</div> : null}

          <div className="pf-submit-wrap">
            <button className="pf-submit" disabled={submitting}>
              {submitting ? "..." : t.submit}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
